import { render, staticRenderFns } from "./CategoryRight.vue?vue&type=template&id=ae3a9e20&scoped=true"
import script from "./CategoryRight.vue?vue&type=script&lang=js"
export * from "./CategoryRight.vue?vue&type=script&lang=js"
import style0 from "./CategoryRight.vue?vue&type=style&index=0&id=ae3a9e20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3a9e20",
  null
  
)

export default component.exports